import React from 'react';
import styles from './aims.module.css';
import { SUBSCALES, TOTAL_MAX, formatAge, formatDate, formatPercentile } from '../../modules/aims/aims';

const TONE_CLASS = { alert: styles.bandAlert, info: styles.bandInfo, ok: styles.bandOk };

/**
 * Histórico das avaliações AIMS, mais recente primeiro: idade, escore por
 * postura, total, percentil e faixa. `rows`: buildRows de aims.js.
 * `highlightId`: avaliação em destaque no card. `classes`: troca a classe da
 * tabela (o PDF usa a do papel, sem o wrapper de rolagem).
 */
const AimsTable = ({ rows, highlightId, classes }) => {
  const tableClass = classes ? classes.table : styles.table;

  return (
    <div className={classes ? undefined : styles.tableScroll}>
      <table className={tableClass}>
        <thead>
          <tr>
            <th>Data</th>
            <th>Idade</th>
            {SUBSCALES.map((item) => <th key={item.key} className={styles.center}>{item.label}</th>)}
            <th className={styles.center}>Total</th>
            <th className={styles.center}>Percentil</th>
            <th>Faixa</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(({ record, age, total, band }) => (
            <tr key={record.id} className={String(record.id) === String(highlightId) ? styles.highlight : undefined}>
              <td className={styles.num}>{formatDate(record.assessedAt)}</td>
              <td className={styles.age}>{formatAge(age)}</td>
              {SUBSCALES.map((item) => (
                <td key={item.key} className={`${styles.num} ${styles.center}`}>{record[item.key]}/{item.max}</td>
              ))}
              <td className={`${styles.num} ${styles.center} ${styles.total}`}>{total != null ? `${total}/${TOTAL_MAX}` : '-'}</td>
              <td className={`${styles.num} ${styles.center}`}>{formatPercentile(record.percentile)}</td>
              <td>
                {band
                  ? <span className={`${styles.band} ${TONE_CLASS[band.tone]}`}>{band.label}</span>
                  : <span className={styles.muted}>Sem percentil</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AimsTable;
